export const psychiatric = (() => {
    const placeHolderText = 'No depression, anxiety or suicidality. '

    return placeHolderText
})